import { stringify } from 'qs'
import { apiSauceInstance } from 'src/services/api'
import { formatDate } from 'src/utils/formatters'
import { formatDestinoLote } from 'src/utils/formatters/formatDestinoLote'
import { XLSXData } from '../types'
import { freteSubcontratadoParaPlanilha } from '../utils/formatFreteSubcontratado'

interface Props {
  limit?: number
  grupoNegociadorId?: string
  centroCustoId?: string
  operacaoKMM?: string
  filialPC?: string
  numeroPC?: string
  codigo?: string
  produtoId?: string
  origemId?: string
  destinoId?: string
  numeroPedido?: string
  dataInicio?: string
  dataTermino?: string
  status?: string
  createdAt?: string
  filialEmissao?: string
  pagadorTomador?: string
  enderecoPagadorTomador?: string
  remetente?: string
  enderecoRemetente?: string
  destinatario?: string
  enderecoDestinatario?: string
  localColeta?: string
  enderecoLocalColeta?: string
  localEntrega?: string
  enderecoLocalEntrega?: string
  codigoTabelaFrete?: string
  codigoTarifaTabela?: string
}

export const useLotesXLSX = (props: Props) => {
  const query = stringify({ ...props, limit: props.limit || 10 })

  function getXLSXData() {
    return apiSauceInstance.get<XLSXData[], { message: string }>(
      `lotes/xlsx-data?${query}`
    )
  }

  function format(data: XLSXData[]) {
    return data.map(lote => ({
      CentroCusto: lote.centroCusto,
      UnidadeNegocio: lote.unidadeNegocio,
      OperacaoKMM: lote.operacaoKMM,
      FilialPC: lote.filialPC,
      NumeroPC: lote.numeroPC,
      Status: lote.status,
      Cliente: lote.cliente,
      Origem: lote.Origem.cidade + '/' + lote.Origem.siglaEstado,
      Destino: formatDestinoLote(lote.Destino),
      DataInicialRetirada: formatDate(lote.dataInicio),
      DataLimiteRetirada: formatDate(lote.dataTermino),
      LocalCarregamento: lote.localCarregamento || 'N/A',
      Produto: lote.Produto?.nome || 'N/A',
      TipoLote: lote.tipoLote,
      Quantidade: lote.quantidadeTotal,
      TipoNegociacaoEmpresa: lote.tipoNegociacaoEmpresa,
      FreteEmpresa: lote.freteEmpresa,
      TipoNegociacaoSubcontratado: lote.tipoNegociacaoSubcontratado,
      FreteAgregado: lote.freteAgregado,
      FreteGrupo: lote.freteGrupo,
      FreteSubcontratadoPJ: freteSubcontratadoParaPlanilha(
        lote.freteSubcontratadoPJ,
        lote.tipoNegociacaoSubcontratado
      ),
      FreteSubcontratadoPF: freteSubcontratadoParaPlanilha(
        lote.freteSubcontratadoPF,
        lote.tipoNegociacaoSubcontratado
      ),
      NumeroPedido: lote.numeroPedido,
      Codigo: lote.codigo,
      filialEmissao: lote.filialEmissao,
      pagadorTomador: lote.pagadorTomador,
      enderecoPagadorTomador: lote.enderecoPagadorTomador,
      remetente: lote.remetente,
      enderecoRemetente: lote.enderecoRemetente,
      destinatario: lote.destinatario,
      enderecoDestinatario: lote.enderecoDestinatario,
      localColeta: lote.localColeta,
      enderecoLocalColeta: lote.enderecoLocalColeta,
      localEntrega: lote.localEntrega,
      enderecoLocalEntrega: lote.enderecoLocalEntrega,
      codigoTabelaFrete: lote.codigoTabelaFrete,
      codigoTarifaTabela: lote.codigoTarifaTabela
    }))
  }

  return {
    getXLSXData,
    format
  }
}
